import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CoreStorageService } from 'pn-core-code';

import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

import { environment } from '@env';

export const authGuard: CanActivateFn = (route, state) => {
  const storage = inject(CoreStorageService);
  const router = inject(Router);
  const localize = inject(LocalizeRouterService)

  const accessToken = storage.getItem('access_token');
  if (!accessToken) {
    router.navigate([localize.translateRoute(environment.loginScreenRoute)]);
    return false;
  } else {
    return true;
  }
};
